import { useQuery } from "@tanstack/react-query";
import { type ReactNode } from "react";
import { useJwt } from "common-frontend-components";
import { useMemo } from "react";

import { adminAxiosInstance } from "@pulse/api/axiosInstance";
import { StorageContext } from "./storageContext";

export default function StorageProvider({ children }: { children: ReactNode }) {
    const { userId } = useJwt();

    const authenticated = useMemo(() => {
        return !!userId;
    }, [userId]);

    const { data } = useQuery({
        queryKey: ["StorageUrl"],
        queryFn: async () => (await adminAxiosInstance.get(`admin/env/storageUrl`)).data.data,
        staleTime: Infinity,
        enabled: authenticated,
    });
    return <StorageContext.Provider value={{ url: data }}>{children}</StorageContext.Provider>;
}
